import { render, staticRenderFns } from "./newHotelOrder.vue?vue&type=template&id=137b1ce2&scoped=true&"
import script from "./newHotelOrder.vue?vue&type=script&lang=js&"
export * from "./newHotelOrder.vue?vue&type=script&lang=js&"
import style0 from "./newHotelOrder.vue?vue&type=style&index=0&id=137b1ce2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137b1ce2",
  null
  
)

export default component.exports